import { render, staticRenderFns } from "./BetList.vue?vue&type=template&id=3ff521d1&"
import script from "./BetList.vue?vue&type=script&lang=js&"
export * from "./BetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports